import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

/**
 * SearchBox — reusable search input, matching List Partner / List Customer style.
 */
export const SearchBox = ({
  value = "",
  onChange = () => {},
  placeholder = "Search...",
  options = null,
  selected,
  onSelect = () => {},
  className = "",
}) => {
  return (
    <div className={`flex flex-col gap-2 sm:flex-row sm:justify-end ${className}`}>
      {options && (
        <select
          value={selected}
          onChange={(e) => onSelect(e.target.value)}
          className="w-full shrink-0 rounded-lg border border-gray-300 py-2 pl-3 pr-8 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 sm:w-40"
          aria-label="Search by"
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}

      <div className="relative w-full max-w-sm">
        <MagnifyingGlassIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
        <input
          type="search"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          aria-label="Search"
        />
      </div>
    </div>
  );
};
